import { ScribeLayout } from '@/app-shell/layout/scribe-layout';
import Community from '@/container/community';
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import posthog from 'posthog-js';
import { useEffect } from 'react';

const CommunityPage = () => {
  const { isAuthenticated } = useIsAuthenticated();

  useEffect(() => {
    posthog.capture('$feature_view', { feature_flag: 'release-template-community' });
  }, []);

  if (isAuthenticated) {
    return (
      <ScribeLayout>
        <Community />
      </ScribeLayout>
    );
  }
  return <Community />;
};

export default CommunityPage;
